import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

export function ProtectedRoute({ page, url, isHome }) {
  const token = localStorage.getItem("_token");

  if (!token && !page?.is_public) {
    return <Navigate to={"/login"} replace />;
  }

  return <Outlet />;
}

export function PublicOnlyRoute({ children }) {
  const { isHome } = children.props || {};
  const token = localStorage.getItem("_token");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (token && location.pathname === "/login") {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate(isHome, { replace: true });
      }
    }
  }, [token, isHome, navigate, location.pathname]);

  if (token) return null;

  return children;
}
